import {
  SEND_EVENT_REQUEST,
  SEND_STATE_CHANGE_EVENT,
} from '../constants/action-types';

export const sendEvent = event => ({
  type: SEND_EVENT_REQUEST,
  event,
});

export const sendStateChange = url => ({
  type: SEND_STATE_CHANGE_EVENT,
  url,
});
